module.exports = __webpack_public_path__ + "img/filter.9895b21d.svg";